import { Popconfirm, Tooltip } from 'antd';
import Button from 'antd/es/button';
import { BaseButtonProps } from 'antd/lib/button/button';

import { TranslationKeys } from '@/components/language/i18n';
import { useTitle } from '@/utils/client_hooks';
import React from 'react';
import { useLanguageContext } from '../../language/LanguageContext';
import CommonIcon, { iconTypesArray } from '../CommonIcon/CommonIcon';

import classNames from 'classnames';
import { COLORS } from '../../../Colors';
import ConfirmButton from './ConfirmButton';
export interface CommonButtonProps extends BaseButtonProps {
  title?: TranslationKeys;
  tooltip?: any;
  onClick?: (any: any) => any;
  onConfirm?: (any: any) => any;
  confirmMessage?: string;
  onCancel?: (any: any) => any;
  icon?: any;
  color?: 'default' | 'primary' | 'danger';
  type?: 'default' | 'primary' | 'dashed' | 'link' | 'text';
  isConfirm?: boolean;
  disabled?: boolean;
  OnlyIcon?: boolean;
  style?: React.CSSProperties;
  iconSize?: number;
  className?: string;
  size?: 'small' | 'middle' | 'large';
  htmlType?: 'button' | 'submit' | 'reset';
}

const CommonButton = React.forwardRef<
  HTMLButtonElement,
  React.PropsWithChildren<CommonButtonProps>
>(function CommonButton(
  {
    icon,
    tooltip,
    onConfirm,
    isConfirm,
    onCancel,
    children,
    confirmMessage,
    type = 'default',
    title: _title = '',
    iconSize = 16,
    onClick,
    color = 'primary',
    ...props
  },
  ref,
) {
  const { t } = useLanguageContext();
  const title = useTitle(_title) || _title;
  const translatedConfirmMessage = confirmMessage || t('globals.confirmAction');

  const buttonClassNames = classNames('ic1-btn', props.className, {
    'ic1-btn-primary':
      type !== 'link' &&
      type !== 'text' &&
      (type === 'primary' || color === 'primary'),
    'ic1-btn-secondary':
      type !== 'link' &&
      type !== 'text' &&
      (type === 'default' || color === 'default'),
    'ic1-btn-danger': type !== 'link' && type !== 'text' && color === 'danger',
    'ic1-btn-text': type === 'link' || type === 'text',
  });

  const iconColor = type === 'default' ? COLORS.secondary : color;
  props.className = buttonClassNames;
  console.log('🚀 ~ className:', props.className);
  if (iconTypesArray.includes(icon)) {
    icon = <CommonIcon icon={icon} size={iconSize} color={iconColor} />;
  }
  if (icon) {
    console.log('🚀 ~ icon:', icon);
  }
  if (isConfirm) {
    if (tooltip) {
      return (
        <Tooltip title={tooltip}>
          <ConfirmButton {...props} icon={icon} type={type}>
            {title || children}
          </ConfirmButton>
        </Tooltip>
      );
    }
    return (
      <ConfirmButton {...props} icon={icon} type={type}>
        {title || children}
      </ConfirmButton>
    );
  }
  if (onConfirm) {
    return (
      <Popconfirm
        title={translatedConfirmMessage}
        onConfirm={onConfirm}
        onCancel={onCancel}
        okText={t('globals.yes')}
        cancelText={t('globals.no')}
      >
        <Button {...props} ref={ref} icon={icon} type={type}>
          {title || children}
        </Button>
      </Popconfirm>
    );
  }
  if (tooltip && !props?.disabled) {
    return (
      <Tooltip title={tooltip}>
        <Button {...props} ref={ref} icon={icon} type={type} onClick={onClick}>
          {title || children}
        </Button>
      </Tooltip>
    );
  }
  return (
    <Button
      {...props}
      ref={ref}
      className={buttonClassNames}
      icon={icon}
      type={type}
      onClick={onClick}
    >
      {title || children}
    </Button>
  );
});

export default CommonButton;
